import axios from '../axiosConfig';

var deployPath = process.env.REACT_APP_SERVER_URL || "";

export default {

  getOccupations: () => {
    return axios.get(`${deployPath}/api/queries/occupations`)
    .then(occupations => {
      return occupations.data;
    })
    .catch(error => {
      // console.log(error);
    });
  },

  getDepartments: () => {
    return axios.get(`${deployPath}/api/queries/departments`)
    .then(departments => {
      return departments.data;
    })
    .catch(error => {
      // console.log(error);
    });
  },

  getCities: (departmentCode) => {
    return axios.get(`${deployPath}/api/queries/cities/${departmentCode}`)
    .then(cities => {
      return cities.data;
    })
    .catch(error => {
      // console.log(error);
    });
  },
  
  getStreets: (departmentCode, cityCode, strSearch) => {
    return axios.get(`${deployPath}/api/queries/streets/${departmentCode}/${cityCode}/${strSearch}`)
    .then(streets => {
      return streets.data;
    })
    .catch(error => {
      // console.log(error);
    });
  },

  getMontevideoNeighborhoods: () => {
    return axios.get(`${deployPath}/api/queries/montevideoNeighborhoods`)
    .then(neighborhoods => {
      return neighborhoods.data;
    })
    .catch(error => {
      // console.log(error);
    });
  },

  getFireOptions: () => {
    return axios.get(`${deployPath}/api/queries/fires`)
    .then(fires => {
      return fires.data;
    })
    .catch(error => {
      // console.log(error);
    });
  },

  getTheftOptions: () => {
    return axios.get(`${deployPath}/api/queries/theft`)
    .then(thefts => {
      return thefts.data;
    })
    .catch(error => {
      // console.log(error);
    });
  },
};
